import React from "react";

/**
 * Sparkline — piccolo grafico area/line SVG (30 punti attività).
 * No dipendenze. Se totale = 0 non renderizza (parent decide fallback).
 */
export default function Sparkline({
    data = [],
    width = 120,
    height = 24,
    stroke = "#94A3B8",
    fillFrom = "#d9f24f",
    strokeWidth = 1.5,
    "data-testid": testid = "sparkline",
}) {
    if (!data || data.length === 0) return null;
    const total = data.reduce((s, x) => s + (x || 0), 0);
    if (total === 0) {
        // linea piatta molto tenue
        return (
            <svg width={width} height={height} data-testid={testid}
                 role="img" aria-label="attività zero" viewBox={`0 0 ${width} ${height}`}>
                <line x1={0} y1={height / 2} x2={width} y2={height / 2}
                      stroke="#E2E8F0" strokeWidth={1} strokeDasharray="2 3" />
            </svg>
        );
    }
    const max = Math.max(...data);
    const stepX = width / Math.max(data.length - 1, 1);
    const points = data.map((v, i) => {
        const x = i * stepX;
        const y = height - ((v || 0) / max) * (height - 2) - 1;
        return [x, y];
    });
    const pathD = points.reduce(
        (acc, [x, y], i) => acc + (i === 0 ? `M${x.toFixed(2)},${y.toFixed(2)}` : ` L${x.toFixed(2)},${y.toFixed(2)}`),
        "",
    );
    // Area path
    const areaD = pathD + ` L${width.toFixed(2)},${height} L0,${height} Z`;
    const gradientId = `sparkgrad-${Math.random().toString(36).slice(2, 8)}`;
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}
             data-testid={testid} role="img"
             aria-label={`attività ultimi 30 giorni: ${total} eventi`}>
            <defs>
                <linearGradient id={gradientId} x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stopColor={fillFrom} stopOpacity="0.35" />
                    <stop offset="100%" stopColor={fillFrom} stopOpacity="0" />
                </linearGradient>
            </defs>
            <path d={areaD} fill={`url(#${gradientId})`} />
            <path d={pathD} fill="none" stroke={stroke} strokeWidth={strokeWidth}
                  strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
